export const DASHBOARD_STATISTICS_RANGES = [
  { label: '今日', value: 'today' },
  { label: '近7天', value: 'last7Days' },
  { label: '近30天', value: 'last30Days' },
  { label: '本月', value: 'month' }
]

function toFiniteNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

function trimDecimal(value) {
  return value.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
}

function formatLocalDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function addDays(date, days) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days)
}

export function getDateRangeParams(range, now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  let startDate = today

  if (range === 'last30Days') {
    startDate = addDays(today, -29)
  } else if (range === 'month') {
    startDate = new Date(today.getFullYear(), today.getMonth(), 1)
  } else if (range !== 'today') {
    startDate = addDays(today, -6)
  }

  return {
    startDate: formatLocalDate(startDate),
    endDate: formatLocalDate(today)
  }
}

export function formatInteger(value, fallback = '--') {
  const number = toFiniteNumber(value)
  if (number === null) return fallback

  const rounded = Math.round(number)
  const abs = Math.abs(rounded)
  const sign = rounded < 0 ? '-' : ''

  if (abs >= 10000) {
    return `${sign}${trimDecimal((abs / 10000).toFixed(1))}万`
  }

  return rounded.toLocaleString('zh-CN')
}

export function formatAmount(value, fallback = '--') {
  const number = toFiniteNumber(value)
  if (number === null) return fallback

  const abs = Math.abs(number)
  const sign = number < 0 ? '-' : ''

  if (abs >= 100000000) {
    return `${sign}¥${trimDecimal((abs / 100000000).toFixed(2))}亿`
  }

  if (abs >= 10000) {
    return `${sign}¥${trimDecimal((abs / 10000).toFixed(2))}万`
  }

  return `${sign}¥${abs.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

export function formatGrowthRate(value) {
  const number = toFiniteNumber(value)
  if (number === null) {
    return {
      text: '暂无变化',
      trend: 'neutral'
    }
  }

  return {
    text: `${number > 0 ? '+' : ''}${number.toFixed(2)}%`,
    trend: number > 0 ? 'up' : number < 0 ? 'down' : 'neutral'
  }
}

export function formatUpdatedTime(value = new Date()) {
  const hours = String(value.getHours()).padStart(2, '0')
  const minutes = String(value.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}
